import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { NotificationApi } from '../api/notification.api';

import { NotificationData } from '../../../interfaces/masters/notification' ;
import { AnyCnameRecord } from 'dns';
@Injectable()
export class NotificationService extends NotificationData {

    constructor(private api: NotificationApi) {
      super();
    }
  
    list(url: string): Observable<any> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<any>{
        return this.api.getById(url);
    }
  
    create(url: string, data:any): Observable<any> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:any): Observable<any> {
      return this.api.update(url,data);
    }
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  